<template>
  <div>
    <PageHeader title="Points de vente" />
    <StoreList />
  </div>
</template>

<script>
import { PageHeader } from "@estaly/ui";
import StoreList from "@/views/stores/StoreList.vue";

export default {
  components: {
    PageHeader,
    StoreList,
  },
};
</script>
